// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

.cont {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
}

ion-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-card {
  background: #fdfdfd;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
ion-card .where {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
ion-card .where a {
  font-size: 1rem;
  font-family: "Roboto", sans-serif;
  text-decoration: none;
  font-weight: 600;
  color: #000;
}
ion-card .where a span {
  display: inline-block;
  border-bottom: 3px solid #14A8CD;
  padding-bottom: 0.5rem;
}
ion-card .where #regis {
  font-weight: 600;
  color: #14A8CD;
}
ion-card img {
  width: 60%;
  padding: 1rem;
}
ion-card form {
  width: 100%;
  height: auto;
}
ion-card .error {
  color: red;
  font-size: 1rem;
  font-weight: bolder;
}
ion-card .correcto {
  color: green;
  font-size: 1rem;
  font-weight: bolder;
}
ion-card ion-item {
  --ion-item-background: none !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
ion-card ion-button {
  height: 4rem;
  font-family: "Roboto", sans-serif;
  font-size: 0.8rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  --background: #14A8CD;
  color: #fff;
}
ion-card ion-button:hover {
  --background: #14A8CD!important;
  color: #fff;
  transition: 1s;
}
ion-card ion-input {
  color: #000;
  font-weight: 600;
  /*--placeholder-color: #000;
  --placeholder-weight: 600;*/
}
ion-card .custom-placeholder {
  color: #000;
  font-size: 1.1rem;
  font-weight: bolder;
}
ion-card ion-label {
  color: black;
  font-weight: 600;
}
ion-card .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color) {
  color: #000;
}
ion-card .item-interactive.item-has-focus {
  --highlight-background: #000;
}
ion-card .forgot {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-card .forgot a {
  font-size: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  color: #000;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
ion-card ion-text {
  color: #000;
}
ion-card ion-list {
  background: none !important;
}
ion-card ion-list ion-item {
  --background: none !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-left: 0;
  padding-right: 0;
}
ion-card ion-list ion-item ion-checkbox {
  width: 1.2rem;
  height: 1.2rem;
  --border-radius: .6rem;
  text-align: center;
}
ion-card ion-list ion-item ion-label {
  margin-left: 1rem;
  white-space: normal !important;
  text-align: center;
}

.mod {
  --background: black;
}

#closeModal {
  font-size: 1.2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  color: #000;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

@media (min-width: 992px) {
  ion-card {
    width: 30em;
  }
  ion-card form ion-item {
    margin-top: 0rem;
    margin-bottom: 0rem;
    margin: 1em 0em;
  }
  ion-card form ion-item ion-toggle {
    padding: 1em 0em;
  }
  ion-card form ion-item ion-label {
    font-weight: 100;
    font-size: 0.9em;
  }
  ion-card ion-list .vrp {
    text-decoration: none;
    font-size: 1.1em;
  }
  ion-card ion-button {
    height: 4em;
    font-family: "Roboto", sans-serif;
    font-size: 0.9em;
    /* letter-spacing: 0.1rem; */
    font-weight: 100;
    --background: #14A8CD;
    color: #fff;
  }
  ion-card ion-text h1 {
    font-size: 1.7em;
    font-weight: 100;
  }
  ion-card .forgot #closeModal {
    margin-top: 0rem;
    margin-bottom: 0rem;
    margin: 1em 0em;
    transition: 0.4s all ease-in-out;
    font-size: 1.1em;
  }
  ion-card .forgot #closeModal:hover {
    color: #14A8CD;
  }
}
.modalRecuperarCss::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}

.modalRecuperarCss::-webkit-scrollbar-thumb {
  background-color: rgba(0, 162, 199, 0.4745098039);
  width: 0.25em;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/modal-registro/modal-registro.page.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;UAAA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uLAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACQ;EACI,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AACZ;AACY;EACI,qBAAA;EACA,gCAAA;EACA,sBAAA;AAChB;AAGQ;EACI,gBAAA;EACA,cAAA;AADZ;AAKI;EACI,UAAA;EACA,aAAA;AAHR;AAMI;EACI,WAAA;EACA,YAAA;AAJR;AAOI;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AALR;AAQI;EACI,YAAA;EACA,eAAA;EACA,mBAAA;AANR;AASI;EACI,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAPR;AAWI;EACI,YAAA;EACA,iCAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AATR;AAYI;EACI,+BAAA;EACA,WAAA;EACA,cAAA;AAVR;AAaI;EACI,WAAA;EACA,gBAAA;EAEA;6BAAA;AAXR;AAeI;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;AAbR;AAgBI;EACI,YAAA;EACA,gBAAA;AAdR;AAiBI;EACI,WAAA;AAfR;AAkBI;EACI,4BAAA;AAhBR;AAmBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBR;AAmBQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAjBZ;AAqBI;EACI,WAAA;AAnBR;AAsBI;EACI,2BAAA;AApBR;AAsBQ;EACI,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AApBZ;AAsBY;EAEI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AArBhB;AAwBY;EACI,iBAAA;EACA,8BAAA;EACA,kBAAA;AAtBhB;;AA4BA;EACI,mBAAA;AAzBJ;;AA4BA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAzBJ;;AA4BA;EACI;IACI,WAAA;EAzBN;EA4BU;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;EA1Bd;EA4Bc;IACI,gBAAA;EA1BlB;EA6Bc;IACI,gBAAA;IACA,gBAAA;EA3BlB;EAiCU;IACI,qBAAA;IACA,gBAAA;EA/Bd;EAmCM;IACI,WAAA;IACA,iCAAA;IACA,gBAAA;IACA,4BAAA;IACA,gBAAA;IACA,qBAAA;IACA,WAAA;EAjCV;EAqCU;IACI,gBAAA;IACA,gBAAA;EAnCd;EAwCU;IACI,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,gCAAA;IACA,gBAAA;EAtCd;EAyCU;IACI,cAAA;EAvCd;AACF;AA4CA;EACI,aAAA;EACA,6BAAA;EACA,aAAA;AA1CJ;;AA6CA;EACI,iDAAA;EAEA,aAAA;AA3CJ","sourcesContent":["*{\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.cont{ \r\n    width: 100%;\r\n    min-height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    backdrop-filter: blur(50px);\r\n}\r\n\r\nion-content{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\nion-card{\r\n    background: #fdfdfd;//     #fdfdfd            #14A8CD\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n    \r\n    .where{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: space-around;\r\n        align-items: center;\r\n        flex-direction: row;\r\n        margin-top: 2rem;\r\n        margin-bottom: 1rem;\r\n\r\n        a{\r\n            font-size: 1rem;\r\n            font-family: 'Roboto', sans-serif;\r\n            text-decoration: none;\r\n            font-weight: 600;\r\n            color: #000;\r\n\r\n            span{\r\n                display:inline-block;\r\n                border-bottom: 3px solid #14A8CD;\r\n                padding-bottom: .5rem;\r\n            }\r\n        }\r\n\r\n        #regis{\r\n            font-weight: 600;\r\n            color: #14A8CD;\r\n        }\r\n    }\r\n\r\n    img{\r\n        width: 60%;\r\n        padding: 1rem;\r\n    }\r\n\r\n    form{\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .error{\r\n        color: red;\r\n        font-size: 1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    .correcto{\r\n        color: green;\r\n        font-size: 1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    ion-item{\r\n        --ion-item-background: none !important;\r\n        margin-top: 2rem;\r\n        margin-bottom: 2rem;\r\n        padding-left: 2rem;\r\n        padding-right: 2rem;\r\n        \r\n    }\r\n\r\n    ion-button{\r\n        height: 4rem;\r\n        font-family: 'Roboto', sans-serif;\r\n        font-size: .8rem;\r\n        letter-spacing: .1rem;\r\n        font-weight: 600;\r\n        --background: #14A8CD;\r\n        color: #fff;\r\n    }\r\n\r\n    ion-button:hover{\r\n        --background: #14A8CD!important;\r\n        color: #fff;\r\n        transition: 1s;\r\n    }\r\n\r\n    ion-input{\r\n        color: #000;\r\n        font-weight: 600;\r\n\r\n        /*--placeholder-color: #000;\r\n        --placeholder-weight: 600;*/\r\n    }\r\n\r\n    .custom-placeholder{\r\n        color: #000;\r\n        font-size: 1.1rem;\r\n        font-weight: bolder;\r\n    }\r\n\r\n    ion-label{\r\n        color: black;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color){\r\n        color: #000;\r\n    }\r\n\r\n    .item-interactive.item-has-focus{\r\n        --highlight-background: #000;\r\n    }\r\n\r\n    .forgot{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        a{\r\n            font-size: 1rem;\r\n            margin-top: 1rem;\r\n            margin-bottom: 1rem;\r\n            color: #000;\r\n            font-weight: 600;\r\n            text-decoration: none;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    ion-text{\r\n        color: #000;\r\n    }\r\n\r\n    ion-list{\r\n        background: none!important;\r\n\r\n        ion-item{\r\n            --background: none !important;\r\n            margin-top: 2rem;\r\n            margin-bottom: 2rem;\r\n            padding-left: 0;\r\n            padding-right: 0;\r\n\r\n            ion-checkbox{\r\n                //border: 1.5px solid black;\r\n                width: 1.2rem;\r\n                height: 1.2rem;\r\n                --border-radius: .6rem;\r\n                text-align: center;\r\n            }\r\n\r\n            ion-label{\r\n                margin-left: 1rem;\r\n                white-space: normal !important;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.mod{\r\n    --background: black;\r\n}\r\n\r\n#closeModal{\r\n    font-size: 1.2rem;\r\n    margin-top: 2rem;\r\n    margin-bottom: 2rem;\r\n    color: #000;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\n@media(min-width: 992px){\r\n    ion-card{\r\n        width: 30em;\r\n\r\n        form{\r\n            ion-item{\r\n                margin-top: 0rem;\r\n                margin-bottom: 0rem;\r\n                margin: 1em 0em;\r\n\r\n                ion-toggle{\r\n                    padding: 1em 0em;\r\n                }\r\n\r\n                ion-label{\r\n                    font-weight: 100;\r\n                    font-size: .9em;\r\n                }\r\n            }\r\n        }\r\n\r\n        ion-list{\r\n            .vrp{\r\n                text-decoration: none;\r\n                font-size: 1.1em;\r\n            }\r\n        }\r\n\r\n        ion-button{\r\n            height: 4em;\r\n            font-family: \"Roboto\", sans-serif;\r\n            font-size: 0.9em;\r\n            /* letter-spacing: 0.1rem; */\r\n            font-weight: 100;\r\n            --background: #14A8CD;\r\n            color: #fff;\r\n        }\r\n\r\n        ion-text{\r\n            h1{\r\n                font-size: 1.7em;\r\n                font-weight: 100;\r\n            }\r\n        }\r\n\r\n        .forgot{\r\n            #closeModal{\r\n                margin-top: 0rem;\r\n                margin-bottom: 0rem;\r\n                margin: 1em 0em;\r\n                transition: .4s all ease-in-out;\r\n                font-size: 1.1em;\r\n            }\r\n\r\n            #closeModal:hover{\r\n                color: #14A8CD;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modalRecuperarCss::-webkit-scrollbar {\r\n    width: .35em;\r\n    background-color: transparent;\r\n    height: .7em;\r\n}\r\n  \r\n.modalRecuperarCss::-webkit-scrollbar-thumb {\r\n    background-color: #00a2c779;\r\n    //border-radius: 1vh;\r\n    width: 0.25em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
